import * as React from 'react';

const IconPolygon = e => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 10 10"
  >
    <path fill="#396DFF" d="M5 10L-8.74228e-07 8.74228e-07L10 0L5 10Z" />
  </svg>
);
export default IconPolygon;
